import React, { useState } from 'react';
import propTypes from 'prop-types';

const AccordionTable = ({
  type,
  title,
  description,
  content,
  showLabel,
  hideLabel,
  open,
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const htmlTitle = { __html: title };
  const htmlDescription = { __html: description };
  const htmlContent = { __html: content };
  const showLabelContent = { __html: showLabel };
  const hideLabelContent = { __html: hideLabel };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <React.Fragment>
      {title && (
        <h3
          className="accordion-table__title"
          dangerouslySetInnerHTML={htmlTitle}
        />
      )}
      {description && (
        <div
          className="accordion-table__description legal__rich-text"
          dangerouslySetInnerHTML={htmlDescription}
        />
      )}
      <div
        className="accordion-table__content"
        id={`${type}-accordion-table-content`}
        role="region"
        aria-labelledby={`${type}-accordion-table-toggle`}
        dangerouslySetInnerHTML={htmlContent}
        hidden={!isOpen}
      />
      <button
        className="accordion-table__toggle"
        id={`${type}-accordion-table-toggle`}
        aria-controls={`${type}-accordion-table-content`}
        aria-expanded={isOpen ? 'true' : 'false'}
        onClick={toggleAccordion}
      >
        <span
          className="accordion-table__toggle-label accordion-table__toggle-label--show"
          dangerouslySetInnerHTML={showLabelContent}
        />
        <span
          className="accordion-table__toggle-label accordion-table__toggle-label--hide"
          dangerouslySetInnerHTML={hideLabelContent}
        />
      </button>
    </React.Fragment>
  );
};

AccordionTable.propTypes = {
  type: propTypes.string.isRequired,
  title: propTypes.string,
  description: propTypes.string,
  content: propTypes.string.isRequired,
  showLabel: propTypes.string.isRequired,
  hideLabel: propTypes.string.isRequired,
  open: propTypes.bool,
};

export default AccordionTable;
